<template>
  <BaseTableItemAction
    v-can:[deletePermission]
    v-on="$listeners"
    v-bind="$attrs"
    icon="mdi-delete"
    actionName="حذف السؤال"
    @click="openDeleteDialog()"
  >
    <DeleteFAQDialog
      :showCondition="showDeleteDialog"
      :item="item"
      @closed="closeDeleteDialog"
    />
    <slot></slot>
  </BaseTableItemAction>
</template>

<script>
import { WRITE_FAQS_PERMISSION } from "@/core/statics/Permissions";
import DeleteFAQDialog from "../dialogs/DeleteFAQDialog.vue";

export default {
  props: {
    item: Object,
  },
  data() {
    return {
      deletePermission: WRITE_FAQS_PERMISSION,
      showDeleteDialog: false,
    };
  },
  methods: {
    openDeleteDialog() {
      this.showDeleteDialog = true;
    },
    closeDeleteDialog() {
      this.showDeleteDialog = false;
    },
  },
  components: { DeleteFAQDialog },
};
</script>
